import {Component} from '@angular/core';

@Component({
  selector: 'app-zone-card',
  templateUrl: './zone-card.component.html',
  styleUrls: ['./zone-card.component.scss']
})
export class ZoneCardComponent {

}
